export enum PriceWithCurrencySize {
  Big = 'big',
  Large = 'large',
}
